<template>
	<div v-if="selectedPlace">
		<div v-if="persons.length">
			<lodging-tabs :close="() => editLodging('close')" v-if="lodgingTab" class="mb-6" />
			<v-skeleton-loader v-else type="table" height="359" width="90%" class="mx-auto my-6" />

			<v-row>
				<v-col cols="12" class="text-center my-0">
					<v-dialog
						v-model="dialogPerson"
						transition="dialog-bottom-transition"
						max-width="800"
					>
						<v-card>
							<v-toolbar color="primary" flat dark>
								Nueva persona
								<v-spacer></v-spacer>
								<v-btn text fab @click="dialogPerson = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-card-text>
								<createPerson :close="() => (dialogPerson = false)" />
							</v-card-text>
						</v-card>
					</v-dialog>
					<div class="d-flex inline">
						<v-btn
							v-if="lodgingPerLabel.length && persons.length"
							x-small
							color="primary"
							@click.stop="moveTimeline('left')"
							class="my-2 "
						>
							<v-icon small left>mdi-arrow-left</v-icon>
						</v-btn>
						<v-tooltip color="warning" bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-bind="attrs"
									v-on="on"
									class="my-2 mx-2 "
									color="primary"
									x-small
									@click="dialogPerson = true"
								>
									<v-icon left>mdi-plus</v-icon>
									<v-icon small left>mdi-account-circle-outline</v-icon>
								</v-btn>
							</template>
							<span>Agregar personas a mi gestión.</span>
						</v-tooltip>

						<v-tooltip color="warning" bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-bind="attrs"
									v-on="on"
									class="my-2 mx-2"
									color="success"
									x-small
									@click.stop="editLodging('close')"
								>
									<v-icon left>mdi-plus</v-icon>
									<v-icon small left>mdi-chart-timeline</v-icon>
								</v-btn>
							</template>
							<span>Cree actividades en el cuadro superior.</span>
						</v-tooltip>

						<v-btn
							v-if="lodgingPerLabel.length && persons.length"
							x-small
							color="primary"
							@click.stop="moveTimeline('right')"
							class=" my-2 "
						>
							<v-icon small right>mdi-arrow-right</v-icon>
						</v-btn>
						<assistant-buttons
							:activities="lodgingPerLabel"
							v-if="itemsPeriods.length && persons.length"
						/>
					</div>

					<span v-if="itemsPeriods.length">
						<template v-for="(item, idPeriod) in itemsPeriods">
							<v-chip
								small
								:key="idPeriod + 'idPeriod1'"
								class="ma-2 white--text"
								:color="item.color"
								@click="selectPeriod(item.period)"
							>
								{{ idPeriod + 1 }}.
								{{ item.period }}
							</v-chip>
						</template>
					</span>
				</v-col>
			</v-row>
			<!-- actividades -->
			<div>
				<v-row class="mt-2">
					<v-col v-if="!lodgingPerLabel.length && persons.length" cols="12">
						<data-empty
							:title="`Sin actividades en ${month}.`"
							:msj="`Presione +Actividad para visualizar el cronograma`"
						/>
					</v-col>
					<v-col v-if="!lodgingPerLabel.length && !persons.length" cols="12">
						<data-empty
							title="Sin personas registradas"
							msj="Para ver y crear actividades deben existir personas bajo su gestión"
						/>
					</v-col>
					<v-col cols="3" class="py-0 my-0" v-if="persons.length">
						<div>
							<v-menu
								v-if="persons.length"
								v-model="menu"
								:close-on-content-click="false"
								max-width="290"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										solo
										dense
										outlined
										filled
										readonly
										small
										label="Mes a trabajar"
										v-bind="attrs"
										v-on="on"
										:value="monthFormatted"
										hide-details
									/>
								</template>
								<v-date-picker
									v-model="month"
									@change="menu = false"
									no-title
									type="month"
									locale="es"
								/>
							</v-menu>
							<v-text-field
								solo
								v-if="lodgingPerLabel.length"
								v-model="filterPerson"
								dense
								outlined
								filled
								small
								class="mt-1"
								label="Filtrar persona"
								hide-details
							/>
						</div>
					</v-col>
					<v-col
						v-if="lodgingPerLabel.length && itemsPeriods.length"
						id="rowDates"
						offset-sm="0"
						cols="9"
						lg="7"
						class="py-0 text-left overflow-x-auto	"
					>
						<div v-scroll:#rowDates="onScrollDate">
							<v-radio-group
								dense
								row
								hide-details
								v-model="toggleIcons"
								class=" text-right d-inline-block mt-0 mb-5"
							>
								<v-radio class="mb-0" :label="'Ver actividades'" :value="'1'" />
								<v-radio class="mb-0" :label="'Ver notificaciones'" :value="'2'" />
								<v-radio class="mb-0" :label="'Ver asistencia'" :value="'3'" />
							</v-radio-group>
							<div class="d-inline-flex">
								<div
									v-for="(date, idRangeDate) in rangeDateTable"
									:key="idRangeDate + 'idRangeDate2'"
									class="itemDateHead"
								>
									{{ date.initialDay }}
								</div>
							</div>
							<div class="d-inline-flex">
								<div
									v-for="(date, idRangeDate) in rangeDateTable"
									:key="idRangeDate + 'idRangeDate3'"
									class="itemDateHead itemInitialDay"
								>
									{{ date.nameDay }}
								</div>
							</div>
						</div>
					</v-col>
					<v-col
						class="hidden-md-and-down pb-0"
						cols="2"
						v-if="lodgingPerLabel.length && itemsPeriods.length"
					>
						<div class="text-left body-1">Precios:</div>
						<v-radio-group dense v-model="radioPrices" class="mt-0" hide-details>
							<v-radio
								v-for="item in ['Servicio', 'Actividad']"
								:key="item"
								class="mb-0"
								:label="item"
								:value="item"
							></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
				<v-row justify="center">
					<v-col v-if="lodgingPerLabel.length" class="pt-0 maxHeightTimeline pb-12">
						<v-row>
							<v-col cols="3">
								<div class="overflow-x-auto">
									<div
										v-for="(lod, labelIndex) in lodgingPerLabel"
										:key="labelIndex"
									>
										<div
											v-if="
												lod.lodgings.length != 0 && lod.persons.length != 0
											"
											class="labelMaxWidth"
										>
											<h4 class="text-uppercase">
												{{ lod.label }}
											</h4>
										</div>
										<div
											v-for="(person, personIndex) in lod.persons"
											:key="personIndex"
											class="itemPerson"
										>
											<template v-if="$vuetify.breakpoint.lgAndUp">
												<span>
													<v-icon
														v-if="person.isUser == false"
														small
														color="accent"
													>
														mdi-account-multiple-remove
													</v-icon>
													<v-icon
														v-if="person.isUser == true"
														small
														color="info"
													>
														mdi-account-multiple-check
													</v-icon>
													<v-icon
														v-if="person.isPhoneVerified == 2"
														small
														color="success"
													>
														mdi-cellphone-basic
													</v-icon>
													<v-icon
														v-if="person.isPhoneVerified == 1"
														small
														color="warning
												"
													>
														mdi-cellphone-basic
													</v-icon>
													<v-icon
														v-if="person.isPhoneVerified == 0"
														small
														color="error"
													>
														mdi-cellphone-basic
													</v-icon>

													<v-tooltip
														v-if="getStatusPerson(person) == 'red'"
														left
													>
														<template v-slot:activator="{ onError }">
															<v-icon
																small
																color="error"
																v-on="onError"
															>
																mdi-alert-circle
															</v-icon>
														</template>
														<span>Sin validar</span>
													</v-tooltip>

													<v-tooltip left>
														<template v-slot:activator="{ onSuccess }">
															<v-icon
																v-if="
																	getStatusPerson(person) ==
																		'green'
																"
																small
																color="success"
																v-on="onSuccess"
															>
																mdi-alert-circle
															</v-icon>
														</template>
														<span>Verificado</span>
													</v-tooltip>
													<v-tooltip
														v-if="getStatusPerson(person) == 'orange'"
														left
													>
														<template v-slot:activator="{ onWarning }">
															<v-icon
																small
																color="warning"
																v-on="onWarning"
																>mdi-alert-circle</v-icon
															>
														</template>
														<span>Pendiente</span>
													</v-tooltip>
												</span>
											</template>

											<span class="text-capitalize">
												<b>
													{{ person.firstName }}
													{{ person.lastName ? person.lastName : '' }} •
												</b>
												{{ person.rut ? person.rut : 'Sin RUT' }} •
												{{
													person.appointment
														? person.appointment
														: 'Sin cargo'
												}}
											</span>
										</div>
									</div>
								</div>
							</v-col>
							<v-col
								id="scroll-target"
								cols="9"
								lg="7"
								class=" text-left overflow-x-auto "
							>
								<div
									v-for="(lod, labelIndex) in lodgingPerLabel"
									:key="labelIndex"
									v-scroll:#scroll-target="onScroll"
								>
									<div v-if="lod.lodgings.length != 0 && lod.persons.length != 0">
										<div class="labelMaxWidth">
											<h4 class="text-uppercase">
												{{ lod.label }}
											</h4>
										</div>
										<div
											v-for="(person, personIndex) in lod.persons"
											:key="personIndex"
										>
											<div class="d-inline-flex">
												<div
													v-for="(date, indexDate) in rangeDateTable"
													:key="indexDate + 'indexDate'"
													:class="{
														itemDateHeadBorderDark:
															$vuetify.theme.isDark,
														itemDateHeadBorderLigth: !$vuetify.theme
															.isDark,
														itemEmptyWeekend:
															(date.initialDay == 'sá' ||
																date.initialDay == 'do') &&
															!verifyItemEmptyToday({
																person,
																date,
															}),
														itemEmptyToday: verifyItemEmptyToday({
															person,
															date,
														}),
													}"
													class="itemEmpty"
													@click.capture="
														selectItemEmpty({
															dateAlltimeline: date,
															person: [person._id],
															group: lod.label,
															place: selectedPlace._id,
														});
														reloadLodgingTab();
													"
												>
													<div
														v-for="(lodging,
														lodgingIndex) in lod.lodgings"
														:key="lodgingIndex"
													>
														<div
															v-if="
																lodging.person == person._id &&
																	lodging.group == lod.label &&
																	compareDates({
																		start: lodging.start,
																		end: lodging.end,
																		dayTable: date.numberDay,
																	})
															"
														>
															<details-lodging
																:periodSelected="periodSelected"
																:periods="itemsPeriods"
																:toggleIconsLabel="
																	toggleIcons == '2'
																"
																:toggleIconsAssistance="
																	toggleIcons == '3'
																"
																:lodging="{ ...lodging }"
																:date="date"
																:compareDates="compareDates"
																:editLodging="editLodging"
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</v-col>
							<v-col
								v-if="
									lodgingPerLabel.length > 0 &&
										!toggleCost &&
										selectedService.price != '0'
								"
								lg="2"
								class="overflow-x-auto hidden-md-and-down"
							>
								<div v-for="(lod, labelIndex) in lodgingPerLabel" :key="labelIndex">
									<div
										v-if="lod.lodgings.length != 0 && lod.persons.length != 0"
										class="labelMaxWidth"
									>
										<h4>
											<b>{{ lod.label }}</b>
										</h4>
									</div>
									<div
										v-for="(person, personIndex) in lod.persons"
										:key="personIndex"
										class="itemTotal"
									>
										<div style="width: 16% !important;">
											{{ person.totalDaysMonth }}
										</div>
										<div>${{ calculatePrice(person, lod) }}</div>
									</div>
								</div>
								<b v-if="calculateTotal != 'Sin valores'">{{ calculateTotal }}</b>
								<b v-else>{{ calculateTotal }}</b>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</div>
			<ubications class="my-3" v-if="itemsPeriods.length && persons.length" />
		</div>
		<div v-else>
			<v-col cols="12">
				<v-dialog
					v-model="dialogPerson"
					transition="dialog-bottom-transition"
					max-width="800"
				>
					<v-card>
						<v-toolbar color="primary" flat dark>
							Nueva persona
							<v-spacer></v-spacer>
							<v-btn text fab @click="dialogPerson = false">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-toolbar>
						<v-card-text>
							<createPerson :close="() => (dialogPerson = false)" />
						</v-card-text>
					</v-card>
				</v-dialog>
				<data-empty
					title="Sin personas registradas"
					msj="Para ver y crear actividades deben existir personas bajo su gestión"
				/>
				<v-tooltip color="warning" bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="my-2 mx-2 "
							color="success"
							x-small
							@click="dialogPerson = true"
						>
							<v-icon left>mdi-plus</v-icon>
							<v-icon small left>mdi-account-circle-outline</v-icon>
						</v-btn>
					</template>
					<span>Agregar personas a mi gestión.</span>
				</v-tooltip>
			</v-col>
		</div>
	</div></template
>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { cloneDeep } from 'lodash';

let moment = extendMoment(Moment);

export default {
	name: 'Activities',
	components: {
		createPerson: () => import('@/components/persons/CreatePerson'),
		LodgingTabs: () => import('@/components/lodgings/LodgingTabs'),
		AssistantButtons: () => import('@/components/lodgings/AssistantButtons'),
		Ubications: () => import('@/components/lodgings/Ubications'),
		DataEmpty: () => import('@/components/ui/DataEmpty'),
		DetailsLodging: () => import('@/components/lodgings/DetailsLodging'),
	},
	data() {
		return {
			lodgingTab: true,
			radioPrices: 'Servicio',
			moveTimelineNumber: 0,
			dialogPerson: false,
			expandHelp: false,
			toggleCost: false,
			toggleIcons: '1',
			containerDates: null,
			filterPerson: '',
			itemsPeriods: [],
			menu: false,
			month: null,
			periodSelected: '',
			sortLabel: [],
			colors: [
				'red',
				'blue',
				'green',
				'indigo',
				'purple',
				'teal',
				'orange',
				'brown',
				'deep-orange',
				'blue-grey',
				'cyan',
			],
		};
	},
	computed: {
		monthFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		lodgingPerLabel() {
			let lodgingFilterLabel = [];
			if (this.persons.length)
				this.labelAvalaibles.forEach(label => {
					let filterLodging = this.filterLodgings.filter(l => {
						return l.group == label.text;
					});
					if (filterLodging.length > 0)
						lodgingFilterLabel.push({
							lodgings: filterLodging,
							label: label.text,
							sortNumber: label.sortNumber,
						});
				});
			lodgingFilterLabel.forEach(lf => {
				let personsFilterLabel = [];
				const searchList = this.filterPerson
					.trim()
					.toLowerCase()
					.split(' ');
				lf.lodgings.forEach(l => {
					if (
						!personsFilterLabel.find(pl => {
							if (pl) return pl._id == l.person;
						})
					) {
						let personOfPersons = cloneDeep(this.persons.find(p => p._id == l.person));
						if (personOfPersons === undefined) return;
						if (this.personsFind(personOfPersons, searchList))
							personsFilterLabel.push(personOfPersons);
					}
				});
				lf.persons = personsFilterLabel;
			});
			lodgingFilterLabel.forEach(lpl => {
				if (lpl.persons)
					lpl.persons.forEach(p => {
						let totalDaysLodgings = 0;
						lpl.lodgings.forEach(l => {
							if (l.person == p._id) {
								//Si parte antes y termina dentro
								if (
									moment(l.start).isBefore(moment(this.rangeDate.start)) &&
									moment(l.end).isSameOrAfter(moment(this.rangeDate.start))
								)
									totalDaysLodgings +=
										moment(l.end).diff(this.rangeDate.start, 'days') + 1;

								//Si parte dentro y termina dsp

								if (
									moment(l.end).isAfter(moment(this.rangeDate.end)) &&
									moment(l.start).isSameOrBefore(moment(this.rangeDate.end))
								)
									totalDaysLodgings +=
										this.rangeDate.end.diff(l.start, 'days') + 1;
								//Dentro

								if (
									moment(l.start).isSameOrAfter(moment(this.rangeDate.start)) &&
									moment(l.end).isSameOrBefore(moment(this.rangeDate.end))
								)
									totalDaysLodgings += moment(l.end).diff(l.start, 'days') + 1;
							}
						});
						p.totalDaysMonth = totalDaysLodgings;
					});
			});
			return lodgingFilterLabel;
		},
		labelAvalaibles() {
			let labelNames = [];
			if (!labelNames.some(group => group.value == 'Sin periodo'))
				labelNames.push({
					value: 'Sin periodo',
					text: 'Sin periodo',
					sortNumber: -1,
				});
			let newIndex = 0;
			this.filterLodgings.forEach(lod => {
				if (lod.group)
					if (!labelNames.some(group => group.value == lod.group)) {
						labelNames.push({
							value: lod.group,
							text: lod.group,
							sortNumber: newIndex,
						});
						newIndex++;
					}
			});
			labelNames.forEach(ln => {
				if (this.sortLabel.length > 0) {
					let sls = this.sortLabel.find(sl => sl.name == ln.text);
					if (sls) ln.sortNumber = sls.count;
				}
			});
			labelNames = labelNames.sort((a, b) => {
				if (a.text > b.text) return 1;
				if (a.text < b.text) return -1;
				return 0;
			});

			return labelNames;
		},
		calculateTotal() {
			let total = 0;
			let total2 = 0;
			if (this.radioPrices == 'Actividad') {
				this.lodgingPerLabel.forEach(lpl => {
					lpl.persons.forEach(person => {
						lpl.lodgings.forEach(lod => {
							if (person._id == lod.person && lod.price) total += lod.price;
						});
					});
				});
				if (total) return total;
				else return 0;
			}
			if (this.radioPrices == 'Servicio') {
				this.lodgingPerLabel.forEach(lpl => {
					lpl.persons.forEach(
						person => (total2 += person.totalDaysMonth * lpl.lodgings[0].service.price)
					);
				});
				return total2;
			}
			return 0;
		},
		filterLodgings() {
			if (this.selectedService && this.selectedPlace) {
				if (this.periodSelected)
					return this.lodgings.filter(
						lod =>
							((moment(lod.start).isBefore(moment(this.rangeDate.start)) &&
								moment(lod.end).isSameOrAfter(moment(this.rangeDate.start))) ||
								(moment(lod.end).isAfter(moment(this.rangeDate.end)) &&
									moment(lod.start).isSameOrBefore(moment(this.rangeDate.end))) ||
								(moment(lod.start).isSameOrAfter(moment(this.rangeDate.start)) &&
									moment(lod.end).isSameOrBefore(moment(this.rangeDate.end)))) &&
							lod.room === this.periodSelected &&
							lod.service._id === this.selectedService._id
					);
				else
					return this.lodgings.filter(
						lod =>
							((moment(lod.start).isBefore(moment(this.rangeDate.start)) &&
								moment(lod.end).isSameOrAfter(moment(this.rangeDate.start))) ||
								(moment(lod.end).isAfter(moment(this.rangeDate.end)) &&
									moment(lod.start).isSameOrBefore(moment(this.rangeDate.end))) ||
								(moment(lod.start).isSameOrAfter(moment(this.rangeDate.start)) &&
									moment(lod.end).isSameOrBefore(moment(this.rangeDate.end)))) &&
							lod.service._id === this.selectedService._id
					);
			}
			return [];
		},
		rangeDateTable() {
			let dates = [];
			let numberDays = this.rangeDate.end.diff(this.rangeDate.start, 'days');
			for (let i = 0; i <= numberDays; i++)
				dates.push({
					numberDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('YYYY-MM-DD'),
					nameDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('DD'),
					initialDay: moment(this.rangeDate.start)
						.add(i, 'day')
						.format('dd'),
					dateMoment: moment(this.rangeDate.start).add(i, 'day'),
				});

			return dates;
		},
		...mapGetters({
			itemEmpty: 'Lodging/itemEmpty',
			loadingLodgings: 'Lodging/loadingLodgings',
			lodgings: 'Lodging/lodgings',
			lodgingSelect: 'Lodging/lodgingSelect',
			lodgingWithProblems: 'Lodging/lodgingWithProblems',
			persons: 'Person/persons',
			rangeDate: 'Lodging/rangeDate',
			selectedPlace: 'Lodging/selectedPlace',
			selectedService: 'Lodging/selectedService',
		}),
	},
	watch: {
		month(newVal) {
			this.setRangeDate({
				start: moment(newVal).date(1),
				end: moment(newVal)
					.clone()
					.endOf('month'),
			});
		},
		filterLodgings() {
			this.setItemsPeriods();
		},
	},
	mounted() {
		this.month = moment()
			.date(1)
			.format('YYYY-MM');
		this.setRangeDate({
			start: moment().date(1),
			end: moment()
				.clone()
				.endOf('month'),
		});
		this.setItemsPeriods();
	},
	methods: {
		reloadLodgingTab() {
			this.lodgingTab = false;
			setTimeout(() => (this.lodgingTab = true), 10);
		},
		calculatePrice(person, lod) {
			let amount = 0;
			if (this.radioPrices == 'Actividad') {
				lod.lodgings.forEach(lod => {
					if (person._id == lod.person && lod.price) amount += lod.price;
				});
				if (amount) return amount;
				else return 0;
			}
			if (this.radioPrices == 'Servicio')
				return person.totalDaysMonth * this.selectedService.price;
		},
		moveTimeline(dir) {
			if (dir == 'left' && this.moveTimelineNumber >= 50)
				this.moveTimelineNumber = this.moveTimelineNumber - 50;

			if (
				dir == 'right' &&
				this.moveTimelineNumber < 650 &&
				!this.$vuetify.breakpoint.lgAndUp
			)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;
			if (dir == 'right' && this.moveTimelineNumber < 250 && this.$vuetify.breakpoint.lgAndUp)
				this.moveTimelineNumber = this.moveTimelineNumber + 50;
			this.containerDates = this.$el.querySelector('#rowDates');
			this.containerDates.scrollLeft = this.moveTimelineNumber;
			this.containerDates = this.$el.querySelector('#scroll-target');
			this.containerDates.scrollLeft = this.moveTimelineNumber;
		},
		setItemsPeriods() {
			this.itemsPeriods = [];
			this.filterLodgings.forEach(item => {
				if (item.room && !this.itemsPeriods.some(el => el.period == item.room))
					this.itemsPeriods.push({ period: item.room });
				// Establece el color de los periodos
				// El counter maximo debe ser hasta numero de colores en this.colors
				let counter = 0;
				this.itemsPeriods = this.itemsPeriods.map(el => {
					const element = { period: el.period, color: this.colors[counter] };
					counter == 10 ? (counter = 0) : counter++;
					return element;
				});
			});
		},
		onScroll(e) {
			this.containerDates = this.$el.querySelector('#rowDates');
			this.containerDates.scrollLeft = e.target.scrollLeft;
		},
		onScrollDate(e) {
			this.containerDates = this.$el.querySelector('#scroll-target');
			this.containerDates.scrollLeft = e.target.scrollLeft;
		},
		personsFind(person, searchList) {
			let itemText = person.firstName + person.lastName + person.rut;
			itemText = itemText.toLowerCase();
			let count = 0;
			searchList.forEach(b => {
				if (itemText.indexOf(b) > -1) count++;
			});
			return searchList.length === count;
		},
		moveLabel(dir, index, name) {
			if (!this.sortLabel.some(s => s.name == name)) this.sortLabel.push({ name });
			this.sortLabel = this.sortLabel.map(item => {
				if (dir == 'up' && item.name == name)
					item.count
						? item.count >= 0
							? (item.count -= 1)
							: null
						: (item.count = index - 1);
				if (dir == 'down' && item.name == name)
					item.count ? (item.count += 1) : (item.count = index + 1);
				return {
					name: item.name,
					count: item.count,
				};
			});
		},
		getStatusPerson(person) {
			if (!person.documents.length && person.typeDocument.length) {
				return 'red';
			} else {
				if (person.typeDocument.some(doc => doc !== null && doc.done === false))
					return 'orange';
				else return 'green';
			}
		},
		verifyItemEmptyToday(payload) {
			const today = moment().format('YYYY-MM-DD');
			if (this.itemEmpty) {
				return (
					(payload.person._id == this.itemEmpty.person._id &&
						payload.date.numberDay == this.itemEmpty.date.numberDay) ||
					moment(today).isSame(moment(payload.date.numberDay))
				);
			} else {
				if (moment(today).isSame(moment(payload.date.numberDay))) return true;
				else return false;
			}
		},
		selectPeriod(period) {
			this.periodSelected = this.periodSelected ? '' : period;
		},
		editLodging(lodging) {
			if (this.lodgingSelect == lodging || lodging == 'close') {
				this.setModeEdit(false);
				this.setLodgingSelect(null);
				this.selectItemEmpty(null);
				this.reloadLodgingTab();
				setTimeout(() => {
					//DEJARA ACTIVO EL COLOR ROJO EN EL ITEM PARA Q EL USER LO VEA
					this.setLodgingWithProblems(null);
				}, 8000);
			} else {
				this.setModeEdit(true);
				this.setLodgingSelect(lodging);
				this.setLodgingWithProblems(null);
				this.reloadLodgingTab();
			}
		},
		compareDates(payload) {
			if (payload.text) {
				return (
					(moment(payload.start).month() !==
						moment(this.rangeDateTable[0].numberDay).month() &&
						moment(payload.dayTable).isSame(
							moment(this.rangeDateTable[0].numberDay)
						)) ||
					moment(payload.dayTable).isSame(moment(payload.start))
				);
			} else {
				return (
					moment(payload.dayTable).isSameOrAfter(moment(payload.start)) &&
					moment(payload.dayTable).isSameOrBefore(moment(payload.end))
				);
			}
		},
		...mapMutations({
			selectItemEmpty: 'Lodging/selectItemEmpty',
			setLodgingWithProblems: 'Lodging/setLodgingWithProblems',
			setModeEdit: 'Lodging/setModeEdit',
			setRangeDate: 'Lodging/setRangeDate',
			setLodgingSelect: 'Lodging/setLodgingSelect',
		}),
	},
};
</script>

<style lang="scss" scoped>
.maxHeightTimeline {
	max-height: 400px;
	overflow-y: auto;
	margin-bottom: 20px;
}

.v-icon {
	position: static !important;
}
.labelMaxWidth {
	width: max-content;
}
.itemEmpty:hover {
	background-color: #80808040 !important;
}
.itemEmptyToday {
	background-color: #6a31ff61 !important;
}
.itemEmptyWeekend {
	background-color: #80808059 !important;
}
.itemTotal div {
	display: inline-block;
	width: 60%;
	height: 15px;
}
.itemNamePeriodSelect {
	border: 2px solid #ad1f98 !important;
	border-radius: 25px;
}
.itemInitialDay {
	border-left: 1px solid white;
	border-right: 1px solid white;
}
.itemTotal {
	height: 15px;
	max-width: 150px;
	background-color: white;
	text-align: left;
	padding-left: 15px;
	padding-right: 15px;
	margin-bottom: 7px;
	display: flex;
	background-color: transparent;
	font-size: 12px;
}
.itemPerson {
	margin-bottom: 7px;
	height: 15px;
	width: max-content;
	background-color: white;
	text-align: left;
	font-size: 12px;
	line-height: 13px;
	border-left: 4px solid transparent;
	background-color: transparent;
}
.nameMonth {
	width: 300px;
	text-align: left;
}
.itemEmpty {
	height: 15px !important;
	max-height: 15px !important;
	margin-bottom: 7px;
	width: 30px;
	background-color: #477a8621;
}
.itemDateHeadBorderDark {
	border-right: 1px solid black;
}
.itemDateHeadBorderLigth {
	border-right: 1px solid white;
}
.itemDateHead {
	width: 30px;
	height: 15px;
	align-items: center;
	text-align: center;
	border-right: 1px solid #477a8621;
	border-left: 0px;
}
</style>
